import type { KaiMailReviewContext } from "@/services/kaiApi";

/** Compact subject + sender line for the chat bubble (no internal ids). */
export function mailReviewHumanReference(ctx: KaiMailReviewContext): string | null {
  const subject = ctx.subject?.trim();
  const from = ctx.from_address?.trim();
  if (subject && from) return `${subject} — from ${from}`;
  if (subject) return subject;
  if (from) return `from ${from}`;
  return null;
}

/**
 * User-visible follow-up after clicking a row on a mail-review card. Ids live in
 * `client_context.mail_review_context`; this string is only for thread readability.
 */
export function buildMailReviewUserPrompt(
  ctx: KaiMailReviewContext,
  action: string,
): string {
  const ref = mailReviewHumanReference(ctx);
  if (!ref) return action;
  return `${action}\n\n(${ref})`;
}
